'use client';

import { useEffect } from 'react';

export default function PWARegister() {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker?.register('/sw.js')?.then((registration) => {
            console.log('[PWA] Service worker registered:', registration?.scope);
          })?.catch((error) => {
            console.warn('[PWA] Service worker registration failed:', error);
          });
      });
    }
  }, []);

  return null;
}
